module.exports = __webpack_public_path__ + "static/media/medal.be02f1f5.svg";